<template>
  <div
    class="f-field"
    :class="{'f-field--danger': error !== null}"
  >
    <label
      v-if="showLabel"
      :class="{'f-field__label--required': isRequired }"
      class="f-field__label"
    >{{ $t(`fields.${fieldName}.label`) }}</label>
    <div class="f-inline-group">
      <div class="f-field">
        <label
          v-show="!date.day && date.day !== ''"
          class="f-field__label--select"
          :for="`day-${fieldName}`"
        >{{ $t('fields.date.day') }}</label>
        <select
          :id="`day-${fieldName}`"
          v-model="date.day"
          class="f-field__input f-field__input--select f-field__input--is-filled"
        >
          <option value="">
            --
          </option>
          <option
            v-for="d in days"
            :key="d"
            :value="d"
          >
            {{ d }}
          </option>
        </select>
      </div>
      <div class="f-field">
        <label
          v-show="!date.month && date.month !== ''"
          class="f-field__label--select"
          :for="`month-${fieldName}`"
        >{{ $t('fields.date.month') }}</label>
        <select
          :id="`month-${fieldName}`"
          v-model="date.month"
          class="f-field__input f-field__input--select f-field__input--is-filled"
        >
          <option value="">
            --
          </option>
          <option
            v-for="m in 12"
            :key="m"
            :value="m"
          >
            {{ $t(`months.${m}`) }}
          </option>
        </select>
      </div>
      <div class="f-field">
        <label
          v-show="!date.year && date.year !== ''"
          class="f-field__label--select"
          :for="`year-${fieldName}`"
        >{{ $t('fields.date.year') }}</label>
        <select
          :id="`year-${fieldName}`"
          v-model="date.year"
          :required="isRequired"
          class="f-field__input f-field__input--select f-field__input--is-filled"
        >
          <option
            v-if="!isRequired"
            value=""
          >
            --
          </option>
          <option
            v-for="y in years"
            :key="y"
            :value="y"
          >
            {{ y }}
          </option>
        </select>
      </div>
    </div>
    <div
      v-if="$slots && $slots.default && !!$slots.default[0]"
      class="f-field__tooltip"
    >
      <Tooltip>
        <slot />
      </Tooltip>
    </div>
    <Transition name="validation-fade">
      <!-- f-field--danger -->
      <p
        v-if="error !== null"
        class="f-field__validation f-field--danger"
      >
        {{ error.message }}
      </p>
    </Transition>
  </div>
</template>
<script>
import underscore from 'underscore'
import Tooltip from '#src/components/utils/Tooltip.vue'

export default {
  components: {
    Tooltip
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        year: '',
        month: '',
        day: ''
      })
    },
    fieldName: {
      type: String,
      required: true
    },
    yearsExtraRange: {
      type: Number,
      default: 2
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    error: {
      type: Object,
      default: () => {return { status: true }}
    }
  },
  emits: ['input', 'update:modelValue'],
  data: function () {
    return {
      now: new Date(),
      date: this.modelValue
    }
  },
  computed: {
    years() {
      return underscore.range(1500, this.now.getFullYear() + 1 + this.yearsExtraRange, 1).reverse()
    },
    days() {
      if ([1, 3, 5, 7, 8, 10, 12].includes(this.date.month)) {
        return 31
      } else if (this.date.month !== 2) {
        return 30
      } else {
        // Is leap year
        if ((this.date.year % 400 === 0) || ((this.date.year % 100 !== 0) && (this.date.year % 4 === 0))) {
          return 29
        } else {
          return 28
        }
      }
    }
  },
  watch: {
    date: {
      deep: true,
      handler(newDate) {
        const date = Object.assign({}, newDate)
        if (!date.day) {
          delete date.day
        }
        if (!date.month) {
          delete date.month
        }
        if (!date.year) {
          delete date.year
        }
        this.$emit('input', date)
        this.$emit('update:modelValue', date)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@use "#src/assets/scss/variables" as *;

.f-field__label--select {
  position: absolute;
  font-size: 1.125rem;
  top: 12px;
  left: 1rem;
  font-weight: 400;
}
</style>
